var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 14.4422C6.48421 15.7969 8.14021 16.6667 9.99935 16.6667C11.6316 16.6667 13.1073 15.9962 14.166 14.9157M7.08268 5.78039C7.94069 5.28407 8.93685 5 9.99935 5C11.6316 5 13.1073 5.67038 14.166 6.75084",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 10.8333C13.3327 12.6743 11.8403 14.1667 9.99935 14.1667C8.15839 14.1667 6.66602 12.6743 6.66602 10.8333C6.66602 8.99242 8.15839 7.5 9.99935 7.5C11.8403 7.5 13.3327 8.99242 13.3327 10.8333Z",
    stroke: "#888888",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.8333V3.33333H16.6667C17.5872 3.33333 18.3333 4.07952 18.3333 5V10.8333H16.25ZM16.25 10.8333V16.6667",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 7.5C4.25316 7.5 4.99935 6.98389 4.99935 5.83333C4.99935 4.68273 4.25316 3.33333 3.33268 3.33333C2.41221 3.33333 1.66602 4.68273 1.66602 5.83333C1.66602 6.98389 2.41221 7.5 3.33268 7.5ZM3.33268 7.5V16.6667",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealsIcon);
export default __webpack_public_path__ + "static/media/meals-icon.a6a6fe8a4c83473ce490e9d812e27268.svg";
export { ForwardRef as ReactComponent };